import { render, staticRenderFns } from "./WorkReview.vue?vue&type=template&id=0b488e3d&"
import script from "./WorkReview.vue?vue&type=script&lang=js&"
export * from "./WorkReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports